import { useEffect, useState } from 'react';
import { returnContainerPointListener } from '~/firebase/listeners/platform';
import { SnapshotFn } from '~/firebase/listeners/type';
import { ReturnContainerPointWithId } from '~/types/platform/returnContainerPoint';

import { PLATFORM_ID } from '~/globalVariables';

export default function useSingleReturnContainerPoint(id: string) {
  const [isInit, setIsInit] = useState<boolean>(false);
  const [returnContainerPoint, setReturnContainerPoint] =
    useState<ReturnContainerPointWithId | null>(null);

  const handleSetReturnContainerPoints: SnapshotFn = (snap) => {
    if (snap.exists()) {
      setReturnContainerPoint({ ...snap.data(), id: snap.id } as ReturnContainerPointWithId);
    } else {
      setReturnContainerPoint(null);
    }
    setIsInit(true);
  };

  useEffect(() => {
    const unlisten = returnContainerPointListener(PLATFORM_ID, id, handleSetReturnContainerPoints);
    return () => {
      unlisten();
    };
  }, []);

  return { isInit, returnContainerPoint };
}
